import { createSelector } from '@reduxjs/toolkit';
import { selectOfferId } from 'shared/selectors/jsonQuery';

export const selectOfferIdFilter = createSelector(selectOfferId, value => ({
  label: 'Номер объявления',
  value: value !== null ? String(value) : '',
}));
